/**
 * 게시물 관련 액션 생성자
 */
import {
  SET_POSTS,
  ADD_POST,
  UPDATE_POST,
  DELETE_POST,
  LIKE_POST,
  UNLIKE_POST,
  ADD_COMMENT,
  DELETE_COMMENT
} from './actionTypes.js';

/**
 * 모든 게시물 설정 액션
 * @param {Array} posts - 게시물 배열
 */
export const setPosts = (posts) => ({
  type: SET_POSTS,
  payload: posts
});

/**
 * 새 게시물 추가 액션
 * @param {Object} post - 게시물 객체
 */
export const addPost = (post) => ({
  type: ADD_POST,
  payload: post
});

/**
 * 게시물 업데이트 액션
 * @param {string} postId - 게시물 ID
 * @param {Object} updateData - 업데이트할 데이터
 */
export const updatePost = (postId, updateData) => ({
  type: UPDATE_POST,
  payload: { postId, updateData }
});

/**
 * 게시물 삭제 액션
 * @param {string} postId - 게시물 ID
 */
export const deletePost = (postId) => ({
  type: DELETE_POST,
  payload: postId
});

/**
 * 게시물 좋아요 액션
 * @param {string} postId - 게시물 ID
 * @param {string} userId - 사용자 ID
 */
export const likePost = (postId, userId) => ({
  type: LIKE_POST,
  payload: { postId, userId }
});

/**
 * 게시물 좋아요 취소 액션
 * @param {string} postId - 게시물 ID
 * @param {string} userId - 사용자 ID
 */
export const unlikePost = (postId, userId) => ({
  type: UNLIKE_POST,
  payload: { postId, userId }
});

/**
 * 댓글 추가 액션
 * @param {string} postId - 게시물 ID
 * @param {Object} comment - 댓글 객체
 */
export const addComment = (postId, comment) => ({
  type: ADD_COMMENT,
  payload: { postId, comment }
});

/**
 * 댓글 삭제 액션
 * @param {string} postId - 게시물 ID
 * @param {string} commentId - 댓글 ID
 */
export const deleteComment = (postId, commentId) => ({
  type: DELETE_COMMENT,
  payload: { postId, commentId }
}); 